import {
    Body,
    Button,
    Collapsible,
    CollapsibleMethods,
    colors,
    Input,
    Spacer,
} from '@spritz-finance/ui'
import { BigNumber, ethers } from 'ethers'
import { useRef, useState } from 'react'
import styled from 'styled-components'
import { ExpandDetailIcon } from '../../../../../components/ExpandedDetailIcon'
import { Column } from '../../../../../components/Layout/Column'
import { Row } from '../../../../../components/Layout/Row'
import { useAllowanceContext } from '../allowance/AllowanceProvider'

const InfoWrapper = styled.div`
    padding: 16px;
    border-radius: 10px;
    background: var(--surface-3, ${colors.silverGray});
    max-width: 495px;
`

const StyledRow = styled(Row)`
    & > div:first-child {
        flex: 1;
    }
`

export const AllowanceConfiguration = () => {
    const { currentAllowance, approve, approveStatus, tokenData } = useAllowanceContext()

    const unlimited = BigNumber.from('0xfffffffffffffffffffffffffff')
    const [open, setOpen] = useState(false)
    const [amount, setAmount] = useState('')
    const content = useRef<CollapsibleMethods>(null)
    const toggle = () => {
        content.current?.toggle()
        setOpen((curr) => !curr)
    }
    const isUnlimited = currentAllowance && currentAllowance.gte(unlimited)
    const allowance = ethers.utils.formatUnits(
        currentAllowance?.toString() ?? '0',
        tokenData?.decimals
    )

    return (
        <Column align="center">
            <Row align="center">
                <Button.Text onClick={toggle}>Advanced Allowance Configuration</Button.Text>
                <ExpandDetailIcon active={open} size={24} style={{ marginLeft: -8 }} />
            </Row>
            <Collapsible ref={content} defaultOpen={false}>
                <InfoWrapper>
                    <Column align="center">
                        <Body.Med size={14} align="center">
                            {`Want more control over how much of your ${tokenData?.symbol} the Spritz smart contract can use? Use the tools below to configure it as you like!`}
                        </Body.Med>
                        <Spacer height={16} />
                    </Column>
                    <Column>
                        <Body.Med size={14}>
                            {`Current Allowance: ${isUnlimited ? 'Unlimited' : allowance} ${
                                tokenData?.symbol
                            }`}
                        </Body.Med>
                        <Spacer height={16} />
                        <StyledRow style={{ width: '100%' }}>
                            <Input
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                type="number"
                                floatingPlaceholder={false}
                                placeholder={`New ${tokenData?.symbol} allowance`}
                            />
                            <Spacer width={16} />
                            <Button.CTA
                                responsive
                                onClick={() => {
                                    if (!amount.length) return
                                    approve(ethers.utils.parseUnits(amount, tokenData?.decimals))
                                }}
                                disabled={approveStatus === 'Mining'}
                            >
                                Set allowance
                            </Button.CTA>
                        </StyledRow>
                        <Spacer height={8} />
                    </Column>
                </InfoWrapper>
            </Collapsible>
        </Column>
    )
}
